import { NotAuthorizedError } from '@/api/errors'

import storage from '../store/storage.js'

const API_URL = process.env.VUE_APP_OW_API_URL

export async function getOWScrims(offset, limit) {
  const response = await fetch(`${API_URL}/matches?offset=${offset}&limit=${limit}`, {
    method: 'GET',
    headers: {
      'x-augment-session-key': storage.getItem('SESSION_KEY'),
      'Content-Type': 'application/json',
    },
  })

  if (!response.ok) {
    switch (response.status) {
      case 401:
        throw new NotAuthorizedError()
      default:
        throw new Error(`Failed to get matches: ${response.statusText}\n${await response.text()}`)
    }
  }

  return await response.json()
}

export async function getOWScrimData(id) {
  const response = await fetch(`${API_URL}/matches/${id}/data`, {
    method: 'GET',
    headers: {
      'X-Augment-Session-Key': storage.getItem('SESSION_KEY'),
      'Content-Type': 'application/json',
    },
  })

  if (!response.ok) {
    switch (response.status) {
      case 401:
        throw new NotAuthorizedError()
      case 404:
        return {}
      default:
        throw new Error(`Failed to get matches: ${response.statusText}\n${await response.text()}`)
    }
  }

  return await response.json()
}

export async function deleteMatch(id) {
  const response = await fetch(`${API_URL}/matches/${id}`, {
    method: 'DELETE',
    headers: {
      'x-augment-session-key': storage.getItem('SESSION_KEY'),
      'Content-Type': 'application/json',
    },
  })

  return response.status === 200
}
